import update from 'immutability-helper'

export function updateMixedBlock(node, action) {
  const { name, value } = action
  return update(node, {
    config: {
      [name]: {
        $set: value,
      },
    },
  })
}
